<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button @click="$router.back()" type="danger" style="margin-right: 10px" icon="el-icon-back"></el-button>
      <el-date-picker
          v-model="choiceDate"
          type="month" value-format="yyyy-MM"
          placeholder="请选择日期"
      />
      <el-cascader collapse-tags style="width: 210px;margin: 0 10px" ref="cascaderRef" placeholder="请选择人员"
                   :options="deptUserTree" v-model="choiceUser"
                   :props="{ multiple: true,label:'name',value:'id'}"></el-cascader>
      <el-select v-model="tableQuery.groupIdList" filterable placeholder="请选择考勤组" multiple  collapse-tags style="margin-right: 10px">
        <el-option v-for="item in attendanceGroup" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button :loading="tableQuery.tableLoading" type="danger" @click="selectTable">搜 索</el-button>
      <el-button type="danger" @click="exportFile">导 出</el-button>
    </div>
    <el-table :data="tableData.resultMap" class="table" height="615px" border v-loading="tableQuery.tableLoading">
      <el-table-column prop="coachName" show-overflow-tooltip label="姓名" width="100"/>
      <el-table-column prop="deptName" show-overflow-tooltip label="部门" width="180"/>
      <el-table-column prop="groupName" show-overflow-tooltip label="考勤组" width="200"/>
      <el-table-column align="center" v-for="(item, index) in tableData.groupDateMap" :key="index" width="120">
        <template #header>
          <div style="font-weight: normal;color: #000000">
            <div style="font-weight: bold;">{{ item.day }}</div>
            <div style="color: #606266;font-size: 12px"
                 :style="(item.dayOfWeek == '六' || item.dayOfWeek == '日' ? 'color:red':'')">
              <span style="margin-right: 2px">周</span>{{ item.dayOfWeek }}
            </div>
          </div>
        </template>
        <template #default="scope">
          <!--          <el-tooltip class="item" effect="dark" placement="top">-->
          <!--            <div slot="content">{{scope.row.clockInAll[index].clockInStr}}</div>-->
          <div style="white-space: pre-wrap" @click="selectItemDefault(scope.row,index)">{{scope.row.clockInAll[index].clockInStr}}</div>
          <!--          </el-tooltip>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.tableTotal">
    </el-pagination>
  </div>
</template>

<script>
import {selectClockInTime,exportClockInTime} from '/src/api/attendance/statistics'
import {selectDeptAndUserTree} from "../../../../../api/contacts/dept";
import {selectAllAttendanceGroup} from "../../../../../api/attendance/attendanceGroup";

export default {
  name: "ClockInTime",
  data() {
    return {
      choiceDate:null,
      choiceUser:[],
      deptUserTree:[],
      attendanceGroup:[],
      tableData:{
        resultMap:[]
      },
      tableQuery:{
        tableTotal:0,
        tableLoading:false,
        coachIdList: [],
        groupIdList: [],
        month: null,
        pageIndex: 0,
        pageSize: 11,
        year: null
      },
    }
  },
  methods:{
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectTable();
    },
    selectTable() {
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      selectClockInTime(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          this.tableData = val.data;
          this.tableQuery.tableTotal = val.data.total;
        }
      })
    },
    exportFile(){
      if (this.choiceDate){
        const parts = this.choiceDate.split('-');
        this.tableQuery.year = parts[0];
        this.tableQuery.month = parts[1];
      }
      this.changePeople();
      this.tableQuery.tableLoading = true;
      exportClockInTime(this.tableQuery).then(val=>{
        this.tableQuery.tableLoading = false;
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    setDefaultData(){
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      this.choiceDate = year+'-'+month;
      this.tableQuery.year = year;
      this.tableQuery.month = month;
      let query = this.$route.query;
      this.item = query.item;
    },
    changePeople(){
      let list = [];
      const ref = this.$refs.cascaderRef;
      if (ref){
        const checkedNodes = ref.getCheckedNodes();
        checkedNodes.forEach((node) => {
          if (node.data.type == 1){//只保留用户不保留部门
            list.push(node.value)
          }
        });
        this.tableQuery.coachIdList = list;
      }
    },
  },
  created() {
    this.setDefaultData();
    this.selectTable();
    selectDeptAndUserTree().then(val=>{
      if (val.status == 200){
        this.deptUserTree=val.data;
      }
    })
    selectAllAttendanceGroup().then(val=>{
      if (val.status == 200){
        this.attendanceGroup=val.data;
      }
    })
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
</style>